import React from "react";
import { useSelector } from "react-redux";
import LoginForm from "components/login/LoginForm";
import AuthHeader from "components/login/AuthHeader";
import { ErrorComponent } from "components";
import WithLoading from "components/Hoc/WithLoading";
import { useIsLoggedIn } from "hooks";
import useDineIn from "../hooks/useDineIn";

const Login = () => {
  useIsLoggedIn();
  const { registerError } = useSelector((state) => state.errorSlice);


  const { goBack, gotoVerification } = useDineIn();

  return (
    <WithLoading>
      <div className="register-page min-h-app-height my-0  py-4 px-5 bg-white">
        <div style={{ color: "white", backgroundColor: "red" }}></div>
        <AuthHeader
          goBack={goBack}
          description="We will send you a WhatsApp message with a one-time verification code"
          title="Enter your"
          blinkText="WhatsApp"
        />
        <LoginForm gotoVerification={gotoVerification} />
        {registerError && (
          <ErrorComponent error={registerError.message ?? registerError} />
        )}
      </div>
    </WithLoading>
  );
};
export default Login;
